import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/vehiclesConstants';

const initialState = {
  vehicles: [],
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const vehiclesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VEHICLES:
      return {
        ...initialState,
      };
    case types.GET_VEHICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicles: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_VEHICLES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VEHICLES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SET_VEHICLES_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_VEHICLES_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_VEHICLES_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_VEHICLES_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default vehiclesReducer;
